import assign from 'lodash/assign';

export default UrlResolverInterceptor;

// @ngInject
function UrlResolverInterceptor($injector) {
  return {
    request: function(config) {
      if (!config.urlConfig) {
        return config;
      }
      // On injecte UrlResolverService au moment voulu pour éviter
      // des problèmes de dépendences cycliques
      return $injector.get('UrlResolverService')
        .resolveUrl(config.url, config.urlConfig)
        .then((resolvedUrl) => {
          return assign(config, {
            url: resolvedUrl
          });
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/interceptors/url-resolver.interceptor.js